import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useMessages } from '@/hooks/useMessages';
import { useUIStore } from '@/stores/uiStore';
import { useState } from 'react';

export default function Header() {
  const { signOut } = useAuth();
  const { data: messagesData } = useMessages('active');
  const activeSection = useUIStore((s) => s.activeSection);
  const setActiveSection = useUIStore((s) => s.setActiveSection);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  // Count unread messages
  const unreadCount =
    messagesData?.messages?.filter((m) => !m.is_read && m.initiated_by === 'agent').length ?? 0;

  const handleSignOut = async () => {
    setMenuOpen(false);
    await signOut();
  };

  return (
    <header className="flex h-14 items-center justify-between border-b border-neutral-300 bg-primary-10 px-4">
      {/* Left: Logo */}
      <div className="flex items-center gap-3">
        <Link to="/app" className="text-xl font-bold">
          <span className="text-white">BAND</span><span className="text-primary-600">JERRY</span>
        </Link>
      </div>

      {/* Center: Navigation tabs (desktop) */}
      <nav className="hidden items-center gap-1 md:flex">
        <button
          onClick={() => {
            setActiveSection('messages');
            navigate('/app/messages');
          }}
          className={`relative rounded-lg px-4 py-2 text-sm font-medium transition-colors ${
            activeSection === 'messages'
              ? 'bg-primary-100 text-primary-600'
              : 'text-neutral-600 hover:bg-neutral-300 hover:text-neutral-800'
          }`}
        >
          Chat
          {unreadCount > 0 && (
            <span className="absolute -right-1 -top-1 flex h-5 w-5 items-center justify-center rounded-full bg-primary-600 text-xs text-black font-bold">
              {unreadCount}
            </span>
          )}
        </button>
        <button
          onClick={() => {
            setActiveSection('sets');
            navigate('/app/sets');
          }}
          className={`rounded-lg px-4 py-2 text-sm font-medium transition-colors ${
            activeSection === 'sets'
              ? 'bg-primary-100 text-primary-600'
              : 'text-neutral-600 hover:bg-neutral-300 hover:text-neutral-800'
          }`}
        >
          Sets
        </button>
        <button
          onClick={() => {
            setActiveSection('tasks');
            navigate('/app/tasks');
          }}
          className={`rounded-lg px-4 py-2 text-sm font-medium transition-colors ${
            activeSection === 'tasks'
              ? 'bg-primary-100 text-primary-600'
              : 'text-neutral-600 hover:bg-neutral-300 hover:text-neutral-800'
          }`}
        >
          Moves
        </button>
        <button
          onClick={() => {
            setActiveSection('kit');
            navigate('/app/kit/link-in-bio');
          }}
          className={`rounded-lg px-4 py-2 text-sm font-medium transition-colors ${
            activeSection === 'kit'
              ? 'bg-primary-100 text-primary-600'
              : 'text-neutral-600 hover:bg-neutral-300 hover:text-neutral-800'
          }`}
        >
          Kit
        </button>
      </nav>

      {/* Right: User menu */}
      <div className="relative">
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="flex items-center gap-2 rounded-lg px-3 py-1.5 text-sm text-neutral-600 hover:bg-neutral-300 hover:text-neutral-800"
          aria-expanded={menuOpen}
          aria-haspopup="true"
        >
          <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
          <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        {menuOpen && (
          <div className="absolute right-0 top-full mt-1 w-48 rounded-lg border border-neutral-300 bg-neutral-200 py-1 shadow-lg">
            <Link
              to="/app/settings"
              onClick={() => setMenuOpen(false)}
              className="block px-4 py-2 text-sm text-neutral-700 hover:bg-neutral-300"
            >
              Settings
            </Link>
            <Link
              to="/app/subscription"
              onClick={() => setMenuOpen(false)}
              className="block px-4 py-2 text-sm text-neutral-700 hover:bg-neutral-300"
            >
              Subscription
            </Link>
            <hr className="my-1 border-neutral-300" />
            <button
              onClick={handleSignOut}
              className="block w-full px-4 py-2 text-left text-sm text-neutral-700 hover:bg-neutral-300"
            >
              Sign Out
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
